import React from 'react';
import { useTranslation } from 'react-i18next';
import { MyProfile } from '@components/templates/myAccount';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';

export function MyProfilePage() {
    const { t } = useTranslation();

    const translations = {
        title: t('my-profile-component.metatags.title'),
        description: t('my-profile-component.metatags.description'),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        url: SITE_URLS.myProfile,
        index: false,
    });

    return <MyProfile />;
}
